module.exports = __webpack_public_path__ + "static/media/5w2h.763e6945.md";